import React, { useEffect } from 'react';
import confetti from 'assets/images/confetti 1.png';
import Button from '../../../components/Button';
import { NavLink, useNavigate } from 'react-router-dom';

const _30_SECONDS = 1000 * 30;

const PurchaseCompletedPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/');
    }, _30_SECONDS);
  }, [navigate]);

  return (
    <>
      <div className="purchase-completed">
        <p className="font-size-6 ">
          Compra realizada <br />
          com sucesso!
        </p>
        <img src={confetti} alt="Chapéu de festa com confetes" />
        <div className="purchase-completed-content">
          <p className="font-size-7">
            Em breve você receberá um SMS com todos os dados da transação.
          </p>
        </div>
        <Button
          color="primary"
          className="btn-lg rounded-5 text-white mt-5"
          tag={NavLink}
          to="/"
        >
          Realizar nova recarga
        </Button>
      </div>
    </>
  );
};

export default PurchaseCompletedPage;
